import BannerImage from "./components/bannerImage/bannerImage";
import FrontPageCategories from "./components/FrontPageCategories/frontPageCategories";
import SliderImages from "./components/SliderImages/sliderImages";

export default function AppSettings(){
    return(
        <div className="flex justify-start items-start w-full flex-col p-10">
            <div className=" text-white font-bold text-md text-left p-2">Front Page Categories</div>
            <FrontPageCategories/>
            <div className=" text-white font-bold text-md text-left p-2 mt-20">Front Page Banner Image</div>
            <BannerImage/>
            <div className=" text-white font-bold text-md text-left p-2 mt-20">Front Page Slider Images</div>
            <SliderImages/>
        </div>
    )
}